(function () {
  'use strict';

  // ────────────────────────────────────────────────────────────────────────
  // CONFIG — variant IDs from src/lib/shopify.ts
  // ────────────────────────────────────────────────────────────────────────
  var VARIANTS = {
    trial:     { id: 42448526016547, qty: 1,  value: 39,  sellingPlan: 4561436707 },
    quarterly: { id: 42448526049315, qty: 1,  value: 79  },
    annual:    { id: 42448526082083, qty: 1,  value: 299 },
    onetime:   { id: 42448526147619, qty: 1,  value: 59  }
  };

  var ANNOUNCEMENTS = [
    'Free priority shipping on every order',
    '100-night money-back promise · keep the product',
    'Limited stock · ships within 24 hours'
  ];

  var RECENT_BUYS = [
    { name: 'Jane M.',    city: 'Dallas, TX',    mins: 2 },
    { name: 'Priya S.',   city: 'Brooklyn, NY',  mins: 4 },
    { name: 'Mariana R.', city: 'Miami, FL',     mins: 7 },
    { name: 'Chloe T.',   city: 'Austin, TX',    mins: 11 },
    { name: 'Alex K.',    city: 'Seattle, WA',   mins: 14 },
    { name: 'Sofia L.',   city: 'Chicago, IL',   mins: 18 },
    { name: 'Hannah P.',  city: 'Denver, CO',    mins: 22 },
    { name: 'Emma W.',    city: 'Boston, MA',    mins: 26 }
  ];

  var STARTING_STOCK = 84;

  // ────────────────────────────────────────────────────────────────────────
  // META PIXEL
  // ────────────────────────────────────────────────────────────────────────
  function initPixel() {
    var id = window.LD_META_PIXEL_ID;
    if (!id || window.fbq) return;
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  function track(event, params) {
    if (window.fbq) window.fbq('track', event, params || {});
  }

  // ────────────────────────────────────────────────────────────────────────
  // ENTRY
  // ────────────────────────────────────────────────────────────────────────
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.querySelector('.ld-root');
    if (!root) return;

    initPixel();

    // ViewContent on mount
    track('ViewContent', {
      content_ids: ['luminadream'],
      content_name: 'LuminaDream Overnight Collagen Eye Patches',
      content_type: 'product',
      currency: 'USD',
      value: VARIANTS.trial.value
    });

    bindBuyButtons(root);
    rotateAnnouncements(root);
    driftCounters(root);
    countdown(root);
    bindFaq(root);
    bindWhatNext(root);
    recentBuyToast(root);
  });

  // ────────────────────────────────────────────────────────────────────────
  // BUY → /cart/add.js → /checkout
  // ────────────────────────────────────────────────────────────────────────
  function bindBuyButtons(root) {
    root.querySelectorAll('[data-ld-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-ld-buy');
        var offer = VARIANTS[key];
        if (!offer) { console.error('Unknown offer:', key); return; }

        var pixelParams = {
          content_ids: ['luminadream'],
          content_name: 'LuminaDream Overnight Collagen Eye Patches',
          content_type: 'product',
          currency: 'USD',
          value: offer.value,
          num_items: offer.qty,
          contents: [{ id: 'luminadream', quantity: offer.qty }]
        };
        track('AddToCart', pixelParams);
        track('InitiateCheckout', pixelParams);

        var originalHTML = btn.innerHTML;
        btn.setAttribute('disabled', 'true');
        btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;">' + spinner() + ' Loading…</span>';

        var body = { id: offer.id, quantity: offer.qty };
        if (offer.sellingPlan) body.selling_plan = offer.sellingPlan;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        }).then(function () {
          // Tell Dawn's cart drawer to refresh, then redirect to checkout
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = '/checkout';
        }).catch(function (err) {
          console.error('Cart add failed:', err);
          btn.removeAttribute('disabled');
          btn.innerHTML = originalHTML;
          alert("Couldn't add to cart. " + (err && err.description ? err.description : 'Please try again.'));
        });
      });
    });
  }

  function spinner() {
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation:ld-spin 1s linear infinite;"><circle cx="12" cy="12" r="9" stroke-opacity="0.25"/><path d="M21 12a9 9 0 0 1-9 9"/></svg>';
  }

  // ────────────────────────────────────────────────────────────────────────
  // ANNOUNCEMENT ROTATOR
  // ────────────────────────────────────────────────────────────────────────
  function rotateAnnouncements(root) {
    var el = root.querySelector('[data-ld-announce]');
    if (!el) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % ANNOUNCEMENTS.length;
      el.textContent = ANNOUNCEMENTS[i];
    }, 4000);
  }

  // ────────────────────────────────────────────────────────────────────────
  // DRIFTING COUNTERS — sold, viewers, stock
  // ────────────────────────────────────────────────────────────────────────
  function driftCounters(root) {
    var sold = 127, viewers = 243, stock = 37;
    var soldEl = root.querySelector('[data-ld-sold]');
    var viewersEl = root.querySelector('[data-ld-viewers]');
    var stockEl = root.querySelector('[data-ld-stock]');
    var stockBar = root.querySelector('[data-ld-stock-bar]');

    function paint() {
      if (soldEl) soldEl.textContent = sold;
      if (viewersEl) viewersEl.textContent = viewers;
      if (stockEl) stockEl.textContent = stock;
      if (stockBar) stockBar.style.width = Math.round((stock / STARTING_STOCK) * 100) + '%';
    }
    paint();

    setInterval(function () {
      sold += Math.floor(Math.random() * 3);
      viewers = Math.max(180, Math.min(320, viewers + (Math.random() > 0.5 ? 1 : -1) * Math.floor(Math.random() * 4)));
      if (stock > 12 && Math.random() > 0.65) stock -= 1;
      paint();
    }, 5000);
  }

  // ────────────────────────────────────────────────────────────────────────
  // DELIVERY ETA — cutoff 3pm
  // ────────────────────────────────────────────────────────────────────────
  function getEta() {
    var now = new Date();
    var cutoff = new Date(now); cutoff.setHours(15, 0, 0, 0);
    var shipsToday = now < cutoff;
    var ship = new Date(now);
    if (!shipsToday) ship.setDate(ship.getDate() + 1);
    var arr = new Date(ship); var added = 0;
    while (added < 2) {
      arr.setDate(arr.getDate() + 1);
      var d = arr.getDay();
      if (d !== 0 && d !== 6) added++;
    }
    var dayName = arr.toLocaleDateString('en-US', { weekday: 'short' });
    var diff = cutoff.getTime() - now.getTime();
    if (diff < 0) diff = 0;
    return {
      hours: Math.floor(diff / 3600000),
      mins: Math.floor((diff % 3600000) / 60000),
      shipsToday: shipsToday,
      arrives: dayName
    };
  }

  function countdown(root) {
    var wrap = root.querySelector('[data-ld-eta]');
    if (!wrap) return;
    function paint() {
      var e = getEta();
      if (e.shipsToday) {
        wrap.innerHTML = 'Order in <span class="ld-tabular" style="font-weight:700;color:var(--ld-accent);">'
          + e.hours + 'h ' + String(e.mins).padStart(2, '0') + 'm</span> → ships today, arrives <strong>' + e.arrives + '</strong>';
      } else {
        wrap.innerHTML = 'Order today → ships tomorrow, arrives <strong>' + e.arrives + '</strong>';
      }
    }
    paint();
    setInterval(paint, 30000);
  }

  // ────────────────────────────────────────────────────────────────────────
  // FAQ ACCORDION
  // ────────────────────────────────────────────────────────────────────────
  function bindFaq(root) {
    var items = root.querySelectorAll('.ld-faq-item');
    // open first by default
    if (items[0]) {
      items[0].querySelector('.ld-faq-a').classList.add('open');
      items[0].querySelector('.ld-faq-icon-plus').style.display = 'none';
      items[0].querySelector('.ld-faq-icon-minus').style.display = '';
    }
    items.forEach(function (item) {
      var btn = item.querySelector('.ld-faq-q');
      btn.addEventListener('click', function () {
        var a = item.querySelector('.ld-faq-a');
        var open = a.classList.contains('open');
        // close all
        items.forEach(function (it) {
          it.querySelector('.ld-faq-a').classList.remove('open');
          it.querySelector('.ld-faq-icon-plus').style.display = '';
          it.querySelector('.ld-faq-icon-minus').style.display = 'none';
        });
        if (!open) {
          a.classList.add('open');
          item.querySelector('.ld-faq-icon-plus').style.display = 'none';
          item.querySelector('.ld-faq-icon-minus').style.display = '';
        }
      });
    });
  }

  // ────────────────────────────────────────────────────────────────────────
  // WHAT HAPPENS NEXT TOGGLE
  // ────────────────────────────────────────────────────────────────────────
  function bindWhatNext(root) {
    var btn = root.querySelector('[data-ld-whatnext-btn]');
    var panel = root.querySelector('[data-ld-whatnext]');
    var chev = btn && btn.querySelector('.ld-rot-chev');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('open');
      if (chev) chev.classList.toggle('open', open);
    });
  }

  // ────────────────────────────────────────────────────────────────────────
  // RECENT PURCHASE TOAST
  // ────────────────────────────────────────────────────────────────────────
  function recentBuyToast(root) {
    var toast = root.querySelector('[data-ld-toast]');
    if (!toast) return;
    var i = 0;
    var dismissed = false;
    var nameEl = toast.querySelector('[data-ld-toast-name]');
    var cityEl = toast.querySelector('[data-ld-toast-city]');
    var minsEl = toast.querySelector('[data-ld-toast-mins]');
    var closeBtn = toast.querySelector('[data-ld-toast-close]');

    function paint() {
      var b = RECENT_BUYS[i];
      nameEl.textContent = b.name;
      cityEl.textContent = 'from ' + b.city;
      minsEl.textContent = b.mins + ' min ago';
    }
    function show() { if (!dismissed) toast.classList.add('open'); }
    function hide() { toast.classList.remove('open'); }

    closeBtn.addEventListener('click', function () { dismissed = true; hide(); });

    paint();
    setTimeout(show, 8000);
    setInterval(function () {
      if (dismissed) return;
      hide();
      setTimeout(function () { i = (i + 1) % RECENT_BUYS.length; paint(); show(); }, 400);
    }, 14000);
  }

  // Inline spinner keyframes (not in CSS to keep it self-contained)
  var style = document.createElement('style');
  style.textContent = '@keyframes ld-spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);
})();
